import {
  useCreateProductPurchase,
  useGetProductPurchase,
} from 'api-hooks/product/order';
import { Notification, KIND } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import ProductOrderForm from './components/form';
import { ProductPurchaseFormType } from './components/form-type';

export type ProductOrderViewParams = {
  id: string;
  defaultValues?: ProductPurchaseFormType;
};

export default function ProductOrderView(
  props: NavigationProps<NavigationRoutes.ProductPurchasesView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetProductPurchase(
    {
      id,
    },
  );
  const { mutateAsync, error: errorMutate } = useCreateProductPurchase();

  const productPurchase = data?.data;

  const onResolve = useApprovalableEdit('product-purchases');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <ProductOrderForm
            {...props}
            renderError={
              !!errorMutate &&
              !!errorMutate.message && (
                <>
                  <Notification
                    overrides={{
                      Body: {
                        style: { width: 'auto', wordBreak: 'break-all' },
                      },
                    }}
                    kind={KIND.negative}
                    closeable
                  >
                    {() => errorMutate.message}
                  </Notification>
                  <SeparatorVertical $margin={8} />
                </>
              )
            }
            productPurchase={productPurchase}
            onSubmit={async (input, form) => {
              const result = await mutateAsync(input);
              onResolve(result);
              return result.data;
            }}
          />
        </>
      }
    />
  );
}
